import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import validator from 'validator';
import ErrorBlock from '@/components/ErrorBlock/ErrorBlock';
import { convertErrors, MyFormTextField } from '../../../MeetupList/components/MeetupEditForm/MeetupEditForm';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const PREFIX = 'UserEditForm';

const classes = {
  root: `${PREFIX}-root`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {},
}));

const UserEditForm = props => {
  // data и errors - передают Начальные значения данных и ошибок. Далее они копируются в стейт и обрабатываются там.
  // handleDataChange - передаёт изменённую копию данных наверх, но она не переносится в data
  const { data, errors, handleDataChange } = props;

  const [formState, setFormState] = useState({
    values: data,
    errors: {},
    touched: {},
    isValid: true,
  });

  useEffect(() => {
    if (errors) {
      setFormState({
        ...formState,
        ...convertErrors(errors),
      });
    }
  }, [errors]);

  const handleChange = (name, value) => {
    formState.values[name] = value;
    formState.touched[name] = true;

    const validateForm = values => {
      const errors = {};

      if (!values.email || validator.isEmpty(values.email)) {
        errors.email = ['Email is required'];
      } else if (!validator.isEmail(values.email)) {
        errors.email = ['Please enter a valid email address'];
      } else if (!validator.isLength(values.email, { max: 64 })) {
        errors.email = ['Email address must be less than 64 characters'];
      }

      if (!values.displayName || validator.isEmpty(values.displayName)) {
        errors.displayName = ['Display name is required'];
      } else if (!validator.isLength(values.displayName, { max: 128 })) {
        errors.displayName = ['Display name must be less than 128 characters'];
      }

      if (!data.userId && !values.password) {
        errors.password = ['Необходимо задать пароль'];
      } else if (values.password && !validator.isLength(values.password, { min: 8 })) {
        errors.password = ['Пароль должен быть не короче 8 символов'];
      } else if (values.password !== values.password2) {
        errors.password2 = ['Пароли должны быть одинаковы'];
      }

      return Object.keys(errors).length > 0 ? errors : null;
    };

    const errors = validateForm(formState.values);

    setFormState(formState => {
      return {
        ...formState,
        isValid: !errors,
        errors: errors || {},
      };
    });

    handleDataChange(formState.values, !errors);
  };

  const error = field => {
    if (!formState.touched || !formState.errors) {
      return null;
    }
    if (formState.touched[field] && formState.errors[field]) {
      return formState.errors[field];
    } else {
      return null;
    }
  };

  const form = {
    // form values bind helper
    data: formState,
    handleChange: handleChange,
    error: error,
  };
  return (
    <Root>
      <ErrorBlock message={formState.error} />
      <Grid container spacing={3}>
        <Grid size={6}>
          <MyFormTextField name={'email'} label='Почта (используется как логин)' required {...form} />
        </Grid>
        <Grid size={6}>
          <MyFormTextField name={'displayName'} label='Имя пользователя' required {...form} />
        </Grid>
        <Grid size={6}>
          <MyFormTextField name={'password'} label='Пароль' type='password' {...form} />
        </Grid>
        <Grid size={6}>
          <MyFormTextField name={'password2'} label='Подтверждение пароля' type='password' {...form} />
        </Grid>
        <Grid size={6}>
          <FormControlLabel
            labelPlacement={'start'}
            control={
              <Checkbox
                checked={formState.values.active}
                name='active'
                onChange={e => handleChange('active', e.target.checked)}
                inputProps={{
                  'aria-label': 'primary checkbox',
                }}
              />
            }
            label='Активен'
          />
        </Grid>
      </Grid>
    </Root>
  );
};

export default UserEditForm;
